import { useState, useEffect } from "react";
import DraggableGrid from "../components/Draggable/DraggableGrid";
import ScrollAnimationBoxes from "../components/Card/ScrollAnimationBoxes";
import ProductForm from "./FirebaseTest/ProductForm";
import AdTemplatePage from "./Template/AdTemplatePage";
import ToggleList from "../components/toggle/toggle";
import LandingA from "./LandingPage/LandingA";
import LandingB from "./LandingPage/LandingB";
import FrameTemplate from "./FrameDesign/FrameTemplate.js";
import RunwayTestList from "./FirebaseTest/RunwayTestScreen.js";
import RunwayVideoGenerator from "./RunwayApi/RunwayVideoGenerator.js";
import OpenApi from "./ChatGpt/GetChatGpt.js";
import NotionPage from "./Notion/NotionPage.js";
import SendEmailPage from "./SendEmail/SendEmailPage.js";
import VideoEdit from "./VideoEditor/Edit.js";

export default function SidebarPage() {
  const [activeTab, setActiveTab] = useState("");
  const [openGroup, setOpenGroup] = useState("");

  const toggleGroup = (groupName) => {
    setOpenGroup((prev) => (prev === groupName ? "" : groupName));
  };

  const menuGroups = [
    {
      group: "기본 정보",
      items: [
        { name: "개인정보약관", content: "개인정보약관 내용입니다." },
        { name: "연락처", content: "연락처 정보입니다." },
        { name: "이용약관", content: "이용약관 내용입니다." },
        { name: "FAQ", content: "자주 묻는 질문입니다." },
      ],
    },
    {
      group: "디자인/UI 컴포넌트",
      items: [
        { name: "드래그 기능", content: <DraggableGrid /> },
        { name: "ScrollAnimationBoxe", content: <ScrollAnimationBoxes /> },
        { name: "ToggleList", content: <ToggleList /> },
        { name: "LandingA", content: <LandingA /> },
        { name: "LandingB", content: <LandingB /> },
        { name: "FrameBanner", content: <FrameTemplate /> },
      ],
    },
    {
      group: "API/데이터",
      items: [
        { name: "Firebase", content: <ProductForm /> },
        { name: "runway", content: <RunwayTestList /> },
        { name: "runwayVideo", content: <RunwayVideoGenerator /> },
        { name: "opengpt", content: <OpenApi /> },
        { name: "notion", content: <NotionPage /> },
      ],
    },
    {
      group: "비디오 편집",
      items: [{ name: "VideoEdit", content: <VideoEdit /> }],
    },
    {
      group: "기타 템플릿",
      items: [
        { name: "AdTemplatePage", content: <AdTemplatePage /> },
        { name: "SendEmailPage", content: <SendEmailPage /> },
      ],
    },
  ];

  // ✅ 초기 해시값으로 탭 설정
  useEffect(() => {
    const hash = decodeURIComponent(window.location.hash.replace("#", ""));
    if (hash) {
      const itemExists = menuGroups.some((group) =>
        group.items.find((item) => item.name === hash)
      );
      if (itemExists) {
        setActiveTab(hash);
        const groupFound = menuGroups.find((group) =>
          group.items.find((item) => item.name === hash)
        );
        if (groupFound) setOpenGroup(groupFound.group);
      }
    } else {
      setActiveTab("개인정보약관");
    }
  }, []);

  const currentContent =
    menuGroups
      .flatMap((group) => group.items)
      .find((item) => item.name === activeTab)?.content || null;

  return (
    <div className="relative row-start-1 grid grid-cols-subgrid lg:col-start-3">
      <div className="flex h-screen">
        <aside className="w-64 bg-gray-800 text-white p-4 space-y-4 overflow-y-auto">
          <h2 className="text-xl font-bold mb-4">메뉴</h2>
          <nav className="space-y-2">
            {menuGroups.map((group) => (
              <div key={group.group}>
                <button
                  onClick={() => toggleGroup(group.group)}
                  className="w-full text-left font-semibold text-lg p-2 rounded bg-gray-700 hover:bg-gray-600"
                >
                  {group.group}
                </button>
                {openGroup === group.group &&
                  group.items.map((item) => (
                    <button
                      key={item.name}
                      onClick={() => {
                        setActiveTab(item.name);
                        window.location.hash = item.name;
                      }}
                      className={`block w-full text-left p-2 pl-4 rounded transition duration-300 ${
                        activeTab === item.name
                          ? "bg-black"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      {item.name}
                    </button>
                  ))}
              </div>
            ))}
          </nav>
        </aside>

        <main className="mx-auto grid w-full max-w-2xl pt-10 md:pb-24 xl:max-w-5xl">
          <div className="gap-10">
            <h1 className="text-2xl font-bold mb-4">{activeTab}</h1>
            {currentContent}
          </div>
        </main>
      </div>
    </div>
  );
}
